'use strict';

angular.module('meanApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('lite-fact-find', {
        url: '/litefactfind',
        templateUrl: 'app/shortFactFind/short-factfind.html',
        controller: 'short-fact-find-controller',
        authenticate: 'user'
      })

      .state('short-fact-find', {
        url: '/short-fact-find/:clientId',
        params: {
          clientId: {
            value: null,
            squash: false
          }
        },
        templateUrl: 'app/shortFactFind/short-factfind.html',
        controller: 'short-fact-find-controller',
        authenticate: ['user','admin']
      });
      
  });
